export const ALL = 'all';
export const FILTERS = [
  { label: 'All', value: ALL },
  { label: 'Event Name', value: 'name' },
  { label: 'Venue/Facility', value: 'facilityName' },
  { label: 'Location', value: 'facilityLocation' },
];
